/* eslint-disable */
import { MailAccountMessageLogsResponseDtoLogItem, fixMailAccountMessageLogsResponseDtoLogItemFromJson, fixMailAccountMessageLogsResponseDtoLogItemToJson } from '../dto/mail-account-message-logs-response-dto-log-item';

export interface MailAccountMessageLogsResponseDto {
  items: MailAccountMessageLogsResponseDtoLogItem[];
}

export const fixMailAccountMessageLogsResponseDtoFromJson = (dto?: MailAccountMessageLogsResponseDto | null): void => {
  if (!dto) {
    return;
  }
  dto.items?.forEach((x, i, a) => fixMailAccountMessageLogsResponseDtoLogItemFromJson(a[i]));
};

export const fixMailAccountMessageLogsResponseDtoToJson = (dto?: MailAccountMessageLogsResponseDto | null): void => {
  if (!dto) {
    return;
  }
  dto.items?.forEach((x, i, a) => fixMailAccountMessageLogsResponseDtoLogItemToJson(a[i]));
};
